module.exports = __webpack_public_path__ + "img/pro_one_3.6d596f9a.jpg";